import { render, staticRenderFns } from "./V3Page.vue?vue&type=template&id=7ee8bf3d"
import script from "./V3Page.vue?vue&type=script&lang=ts"
export * from "./V3Page.vue?vue&type=script&lang=ts"
import style0 from "./V3Page.vue?vue&type=style&index=0&id=7ee8bf3d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports